/**
 * Created by Andrey Popov on 06.06.2024
 */

const PackOfferLogic = function (offer) {
    this.offer = offer;
};

PackOfferLogic.prototype.getStage = function () {
    return this.offer.stage || 0;
};

PackOfferLogic.prototype.getContext = function () {
    return {
        type: "starter_pack",
        offer: this.offer.type,
        name: this.offer.name
    };
};

PackOfferLogic.prototype.getProduct = function () {
    return Product.CreateById(Offers[this.offer.type].productByStage[this.getStage()], this.getContext());
};

PackOfferLogic.prototype.getTimeLeft = function () {
    return undefined;
};

PackOfferLogic.prototype.isIconAvailable = function () {
    return true;
};

PackOfferLogic.prototype.hasIconAttention = function () {
    return false;
};

PackOfferLogic.prototype.processBought = function (success) {
    if (!success) {
        return;
    }

    const product = this.getProduct();
    this.offer.logPurchase(product);

    this.offer.incStage();
    this.offer.complete();
};

PackOfferLogic.RestoreBoughtReward = function (context) {
    const offer = Restorable.FindOffer(context);
    const product = offer && offer.logic.getProduct();
    return product && product.reward;
};

PackOfferLogic.RestoreGive = function (offer, context) {
    if (context.reward) {
        cleverapps.paymentsLogic.showRestoredWindow(context.reward);
    }
    offer.logic.processBought(true);
};

Restorable.BY_TYPE["starter_pack"] = new Restorable({
    find: Restorable.FindOffer,
    give: PackOfferLogic.RestoreGive,
    boughtReward: PackOfferLogic.RestoreBoughtReward
});
